
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceinjalna() {



const cardData = {
  keyword: 'Corporate Cab Service in Jalna MIDC Maharashtra',
  heading: 'eTravo: Corporate Cab Service in Jalna MIDC Maharashtra',
  headingDescription: `eTravo is proud to offer dependable and professional corporate cab services in Jalna MIDC, Maharashtra, tailored to meet the dynamic mobility needs of industrial enterprises, corporate staff, and business executives. With a strong focus on reliability, safety, and timeliness, our services support daily employee transportation, executive transfers, and client visits within this growing industrial region. eTravo’s fleet includes well-maintained, GPS-equipped, air-conditioned vehicles operated by courteous, professionally trained drivers. We provide customized rental packages, efficient route planning, and 24/7 customer assistance, ensuring a smooth and professional travel experience for companies across Jalna MIDC. Choose eTravo for smart, scalable, and stress-free corporate transportation in Maharashtra’s manufacturing corridor.`,

  top: 'Top Places to visit in jalna with eTravo',
  "topPlaces": [
    {
      "title": "Jalna MIDC Industrial Area",
      "description": "One of Maharashtra’s major industrial belts, Jalna MIDC hosts a variety of industries including steel re-rolling mills, cotton ginning factories, agro-based processing units, and seed production companies. eTravo provides dedicated employee transportation solutions with shift-wise scheduling, ensuring operational efficiency for factories, small-scale units, and multinational corporations within the industrial zone."
    },
    {
      "title": "Jalna City Center",
      "description": "The bustling heart of Jalna’s commercial activity, the city center features district-level government offices, banking institutions, corporate branches, and administrative headquarters. eTravo’s executive cab services offer smooth connectivity for employees and managers traveling for official work, meetings, audits, and interdepartmental visits in this high-traffic zone."
    },
    {
      "title": "Jalna Railway Station",
      "description": "A crucial railway hub linking Jalna with Aurangabad, Pune, Hyderabad, and Mumbai. Our station pick-up and drop-off cabs are ideal for business travelers and staff commuting by train. With GPS-enabled vehicles and real-time tracking, eTravo ensures timely transportation for employees arriving on early or late train schedules, particularly during corporate transfers or onboarding of new staff."
    },
    {
      "title": "Jalna Dry Port and Logistics Park",
      "description": "The upcoming multi-modal logistics park near Jalna is poised to become a major inland cargo terminal. It serves large logistics companies, warehousing units, and FMCG distribution hubs. eTravo supports the transport needs of warehouse staff, supervisors, and visiting clients with reliable cab services designed for shift transport and operational runs between dry port terminals and corporate facilities."
    },
    {
      "title": "Rajur Industrial Estate",
      "description": "Located on the Jalna–Aurangabad highway, this estate is home to numerous metal and engineering firms. Our corporate cab services cater to daily workforce transportation, minimizing late arrivals and boosting operational discipline. We also facilitate vehicle rentals for corporate audits, plant inspections, and technical staff visits to and from Rajur."
    },
    {
      "title": "Jalna Agriculture Produce Market Committee (APMC) Yard",
      "description": "One of the key grain and cotton trading hubs in the region, the APMC yard hosts daily business activity involving traders, buyers, and supply chain operators. eTravo offers structured cab services for transport officials, logistics partners, and corporate procurement teams visiting the market for deals and inspections."
    },
    {
      "title": "Seed Processing and R&D Zones",
      "description": "Jalna is known as the seed capital of India, with leading companies like Mahyco and Nuziveedu operating large-scale R&D and production centers. eTravo’s cabs are tailored for daily commuting of scientists, research staff, and administrative teams, ensuring punctual arrivals even during rural route coverage or monsoon disruptions."
    },
    {
      "title": "Steel Industry Zones",
      "description": "Jalna’s steel industry employs thousands and functions on tight production timelines. eTravo enables shift-based transport scheduling, especially for rolling mill workers and QC teams. Our premium services also support executive transfers and regulatory visits for compliance inspections within the industrial premises."
    },
    {
      "title": "Educational and Skill Development Centers",
      "description": "Institutions such as engineering colleges and ITI training centers around Jalna attract students, faculty, and visiting professionals. eTravo provides point-to-point cab solutions for seminars, placement drives, industrial training sessions, and skill-building events, helping educational institutions manage guest and faculty transport smoothly."
    },
    {
      "title": "Business Hotels and Meeting Venues",
      "description": "Jalna has multiple business-friendly hotels like the Ankushrao Patil Sabhagruh and urban stay venues used for corporate events and client meetings. We offer premium cabs for airport pickups, venue drops, and outstation guest travel, maintaining professionalism and punctuality for every high-profile business engagement."
    }
  ],

 services: [
  {
    name: 'Jalna MIDC Corporate Cab Rentals',
    description: `Tailored rental plans crafted for businesses in Jalna MIDC, including options for long-term corporate contracts and short-term event transportation needs. Our flexible packages ensure hassle-free booking, timely service, and a fleet maintained to corporate standards to support your business operations seamlessly.`
  },
  {
    name: 'Employee Transport Cab Jalna MIDC',
    description: `Dependable employee transport aligned with factory and office shift timings, ensuring safe, punctual, and comfortable commutes daily. We use GPS-enabled vehicles monitored by a dedicated support team to guarantee timely arrivals and smooth drop-offs for your workforce every day.`
  },
  {
    name: 'Business Cab Services Jalna MIDC',
    description: `Flexible and prompt cab services designed for business owners and corporate staff traveling for meetings, site visits, and client interactions. Our professional drivers are well-versed with local routes and traffic patterns, providing efficient travel with comfort and reliability.`
  },
  {
    name: 'Corporate Staff Cabs Jalna MIDC',
    description: `Group transport solutions with multi-route planning and GPS tracking, perfect for corporate teams commuting together. This service promotes cost savings, reduces traffic congestion, and ensures employee safety through coordinated batch pickups and drop-offs.`
  },
  {
    name: 'Reliable Corporate Cab Service Jalna MIDC',
    description: `A commitment to consistent quality, featuring clean, well-maintained vehicles and professional drivers to uphold corporate standards. Our focus is on punctuality, courteous service, and proactive communication to meet the unique needs of corporate clients.`
  },
  {
    name: 'AC Corporate Cabs Jalna MIDC',
    description: `Comfort-oriented air-conditioned cabs to provide a pleasant travel experience regardless of Jalna’s weather conditions. Ideal for daily commutes as well as executive rides, our AC fleet ensures a cool and relaxing journey even during peak summer months.`
  },
  {
    name: 'Staff Pickup and Drop Cab Jalna MIDC',
    description: `Comprehensive staff transportation service supporting multiple shifts including night duties, with flexible scheduling and timely pickups. Our 24/7 availability and experienced drivers make sure your workforce travels safely and punctually, round the clock.`
  },
  {
    name: 'Affordable Business Cab Rentals Jalna MIDC',
    description: `Cost-effective cab rental options for small and medium enterprises as well as large corporations, emphasizing transparent pricing and reliability. Our scalable plans allow businesses to adjust vehicle numbers and routes according to evolving operational needs, optimizing transport budgets.`
  },
  {
    name: 'Executive Cab Services Jalna MIDC',
    description: `Premium executive transportation services with experienced chauffeurs, ideal for business meetings, airport transfers, and client hospitality. Our luxury vehicle fleet and discreet, courteous drivers ensure a high-end travel experience for VIPs and senior management.`
  },
  {
    name: 'Monthly Corporate Cab Rentals Jalna MIDC',
    description: `Fixed-route monthly cab plans designed to simplify employee transportation logistics, reduce administrative efforts, and ensure smooth operations. These plans offer consistent service quality, easy billing, and quick adjustments in coordination with HR and admin teams.`
  },
  {
    name: 'Industrial Area Employee Transport Jalna MIDC',
    description: `Optimized employee transport for factories and industrial units, facilitating smooth travel between residential areas and work zones. Our routing and scheduling systems prioritize safety, punctuality, and compliance with industrial regulations.`
  },
  {
    name: 'Corporate Client Cabs Jalna MIDC',
    description: `Dedicated client transport services ensuring punctual, comfortable, and professional travel experience for visiting business guests. From airport pickups to site visits, we help make a great impression with polished vehicles and trained drivers.`
  },
  {
    name: 'Business Meeting Cabs Jalna MIDC',
    description: `Rapid response cab services tailored for executives attending urgent meetings, ensuring timely arrivals within Jalna and nearby locations. We offer easy booking options and prompt dispatch to keep your business running smoothly.`
  },
  {
    name: 'Jalna Industrial Area Cab Hire',
    description: `Flexible, on-demand cab hire services across Jalna’s industrial corridors for site inspections, logistics support, and corporate errands. Our knowledgeable drivers are familiar with the industrial landscape, providing efficient and hassle-free transport solutions.`
  },
  {
    name: 'Corporate Shuttle Cabs Jalna MIDC',
    description: `Group transport services utilizing minibuses or large vans, ideal for bulk employee movement during shift changes or corporate events. This service improves operational efficiency while reducing the environmental footprint through consolidated travel.`
  }
],

tableData: [
  ['Jalna MIDC Corporate Cab Rentals', 'Employee Transport Cab Jalna MIDC'],
  ['Business Cab Services Jalna MIDC', 'Corporate Staff Cabs Jalna MIDC'],
  ['Reliable Corporate Cab Service Jalna MIDC', 'AC Corporate Cabs Jalna MIDC'],
  ['Staff Pickup and Drop Cab Jalna MIDC', 'Affordable Business Cab Rentals Jalna MIDC'],
  ['Executive Cab Services Jalna MIDC', 'Monthly Corporate Cab Rentals Jalna MIDC'],
  ['Industrial Area Employee Transport Jalna MIDC', 'Corporate Client Cabs Jalna MIDC'],
  ['Business Meeting Cabs Jalna MIDC', 'Jalna Industrial Area Cab Hire'],
  ['Corporate Shuttle Cabs Jalna MIDC', '']
],


"whychoose": [
  {
    "WhyChooseheading": "Tailored Corporate Cab Services for Jalna MIDC",
    "WhyChoosedescription": "eTravo offers customized cab solutions designed specifically for businesses operating in Jalna MIDC, an emerging industrial hub in Maharashtra. Our services focus on ensuring timely employee transportation, minimizing delays, and improving overall operational efficiency. With dependable commute options, companies can enhance employee satisfaction while upholding safety and comfort."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Corporate Needs",
    "WhyChoosedescription": "Our diverse fleet includes sedans, SUVs, and multi-utility vehicles, giving your business the flexibility to choose the most suitable mode of transport for executive travel, team commutes, or client transportation. All vehicles are regularly maintained to ensure safety, cleanliness, and reliability."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Knowledge",
    "WhyChoosedescription": "Our skilled drivers are well-acquainted with the roads and industrial layout of Jalna MIDC. Their local expertise guarantees efficient routes, timely pickups and drop-offs, and a professional travel experience aligned with corporate standards."
  },
  {
    "WhyChooseheading": "Flexible Booking Options to Match Shift Patterns",
    "WhyChoosedescription": "Recognizing the varying shift schedules in industrial operations, we provide flexible booking models such as scheduled rides, on-demand services, and long-term transportation contracts—making employee commutes easy to manage."
  },
  {
    "WhyChooseheading": "Real-Time GPS Tracking for Safety and Transparency",
    "WhyChoosedescription": "All our cabs are fitted with GPS systems, allowing real-time ride tracking for employers and administrators. This enhances travel security, ensures driver accountability, and supports quick incident response."
  },
  {
    "WhyChooseheading": "Transparent Billing with Detailed Invoices",
    "WhyChoosedescription": "We offer clear, itemized billing for every trip, with detailed breakdowns that simplify finance tracking, reporting, and reimbursement processes for corporate clients."
  },
  {
    "WhyChooseheading": "Strict Safety and Hygiene Standards",
    "WhyChoosedescription": "Our cabs are sanitized regularly and undergo routine maintenance. Drivers adhere to hygiene and safety protocols to ensure a secure and healthy ride environment for every employee."
  },
  {
    "WhyChooseheading": "Dedicated Account Management Support",
    "WhyChoosedescription": "Each client is assigned a dedicated account manager to streamline bookings, resolve issues quickly, and ensure a smooth, customized corporate transportation experience in Jalna MIDC."
  }
]

}

const faqData = [
  [
    {
      question: "Which areas do your Jalna MIDC cab services cover?",
      answer: "Our services cover the entire Jalna MIDC region and nearby industrial areas, ensuring convenient transportation for your workforce."
    },
    {
      question: "Can we schedule daily or weekly rides for our employees?",
      answer: "Yes, we offer customizable ride schedules for daily, weekly, or shift-based employee commutes."
    },
    {
      question: "Do you offer corporate billing and reporting options?",
      answer: "Absolutely. Corporate clients receive monthly consolidated invoices and trip reports for transparent and streamlined billing."
    },
    {
      question: "Are your drivers familiar with Jalna MIDC routes and protocols?",
      answer: "Yes, our drivers are trained in professional conduct and have thorough knowledge of Jalna MIDC routes and traffic regulations."
    },
    {
      question: "How is passenger safety maintained during rides?",
      answer: "We ensure safety with real-time GPS tracking, sanitized vehicles, verified drivers, and strict safety protocols."
    },
    {
      question: "Is there a dedicated support line for business clients?",
      answer: "Yes, we provide dedicated account managers and priority customer support for all our corporate partners."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Anil Jadhav",
    designation: "Plant Manager, Jalna Auto Components",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo has significantly improved our employee commute experience with their timely and safe cab services.”"
  },
  {
    name: "Ms. Priya Kulkarni",
    designation: "HR Executive, Jalna Pharma Tech",
    rating: [1, 1, 1, 1, 1],
    text: "“We appreciate the professionalism and flexibility eTravo offers. It’s been a hassle-free transportation solution for our company.”"
  }
];

































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Jalna MIDC Maharashtra",
  "image": "https://www.etravo.in/images/keyword/cab-service-jalna-midc.jpg",
  "description": "Reliable corporate cab service in Jalna MIDC Maharashtra offering employee transport, business travel, industrial area cabs, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-service-jalna-midc"
  }
};






    return (
        <div>

<Helmet>
  <title>Corporate Cab Service in Jalna MIDC Maharashtra | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate cab service in Jalna MIDC Maharashtra for staff commute, business meetings, and industrial transport. Affordable AC corporate cabs available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/81.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceinjalna;